import * as React from "react";
import { ChevronDown, AlertCircle } from "lucide-react";

import { cn } from "../lib/utils";
import { Label } from "./ui/label";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
  title: string;
  children: React.ReactNode;
}

const SelectSingle = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ error, title, children, required, disabled, name, className, ...rest }, ref) => {
    const selectId = name || `select-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className="space-y-2">
        <Label
          htmlFor={selectId}
          className={cn(
            "text-sm font-medium text-muted-foreground",
            error && "text-red-600 dark:text-red-400"
          )}
        >
          {title}
          {required && <span className="text-red-500 dark:text-red-400 ml-1">*</span>}
        </Label>
        <div className="relative">
          <select
            id={selectId}
            name={name}
            required={required}
            disabled={disabled}
            ref={ref}
            className={cn(
              "flex h-10 w-full appearance-none rounded-md border bg-background text-foreground px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
              "pr-10", // espaço para o ícone
              error
                ? "border-red-300 dark:border-red-800 focus:ring-red-500"
                : "border-border focus:ring-primary",
              className
            )}
            {...rest}
          >
            {children}
          </select>
          <ChevronDown
            className={cn(
              "absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 pointer-events-none",
              error
                ? "text-red-400"
                : disabled
                ? "text-muted-foreground"
                : "text-primary"
            )}
          />
        </div>
        {error && (
          <div className="flex items-center gap-2 text-sm text-red-600 dark:text-red-400">
            <AlertCircle className="h-4 w-4" />
            <span>{error}</span>
          </div>
        )}
      </div>
    );
  }
);

SelectSingle.displayName = "SelectSingle";

export { SelectSingle };
